import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3 text-size-14" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-3 text-size-14" }, "\n        業務カテゴリを設定することで、対象のお仕事を検索したり、資格登録をしたりすることができるようになります。\n      ", -1)

import { ref, computed } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { authStore } from "@/store/auth";
import WorkTypeRadioGroup from "@/components/molecules/orders/WorkTypeRadioGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkerServiceReSettingModal',
  props: {
  show: {
    type: Boolean,
    required: true,
    default: false
  }
},
  emits: ["submit"],
  setup(__props, { emit }) {





const workerServiceId = ref<number | null>(null);

const product = computed(() => authStore.product);
const workerServiceOptions = computed(() =>
  authStore.product.workerServices.map(ws => ({
    value: ws.id,
    text: ws.displayName
  }))
);

const submit = () => emit("submit", workerServiceId.value);

return (_ctx: any,_cache: any) => {
  const _component_ValidationField = _resolveComponent("ValidationField")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    modelValue: __props.show,
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "hide-header": "",
    "hide-footer": "",
    centered: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CustomValidationObserver, {
        tag: "div",
        initialValues: { workerServiceId: workerServiceId.value },
        ref: "vObserver"
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createElementVNode("p", _hoisted_1, "\n        『" + _toDisplayString(product.value.name) + "』では以下の業務カテゴリのお仕事を探すことができます。\n      ", 1),
          _createTextVNode(),
          _createElementVNode("div", null, [
            _createVNode(_component_ValidationField, {
              label: "業務",
              name: "workerServiceId",
              rules: "required",
              modelValue: workerServiceId.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((workerServiceId).value = $event))
            }, {
              default: _withCtx((validationState) => [
                _createVNode(WorkTypeRadioGroup, {
                  value: workerServiceId.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((workerServiceId).value = $event)),
                  validationState: validationState,
                  name: "workerServiceId",
                  options: workerServiceOptions.value
                }, null, 8, ["value", "validationState", "options"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createTextVNode(),
          _hoisted_2,
          _createTextVNode(),
          _createVNode(AppButton, {
            block: "",
            onClick: ($event: any) => (handleSubmit(submit))
          }, {
            default: _withCtx(() => [
              _createTextVNode("設定する")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["initialValues"])
    ], undefined, true),
    _: 1
  }, 8, ["modelValue"]))
}
}

})